const getPrice = price =>
Intl.NumberFormat(undefined, {
  currency: 'USD',
  minimumFractionDigits: 2,
  style: 'currency',
}).format(parseFloat(price ? price : 0))

export default getPrice